export default __webpack_public_path__ + "static/media/menuPattern.27d3ba8c.png";